import ServiceBase from "base/baseService"

export default class CofinsCstService extends ServiceBase {

    title = "CST do COFINS"
    pluralTitle = "CSTs do COFINS"
    url = '/cadastro/fiscal/cofinscst'
    frontUrl = '/cadastro/fiscal/cofinscst'
    frontUrlList = '/cadastro/fiscal/cofinscstlist'
    primaryKey = 'codigo_cofcst'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        // Strings notNullable
        data.codigo_cofcst = data?.codigo_cofcst || ''
        data.descricao_cofcst = data?.descricao_cofcst || ''
        data.cod_tiflu_cofcst = data?.cod_tiflu_cofcst || ''

        return data
    }

    prepareToSave({ data }) {
        return data
    }

}
